export default __webpack_public_path__ + "static/media/Explore_Places_Bottom.df2024c7.png";